export const COGNITO_ERRORS = {
  noUser: 'User not found.',
  invalidCode: 'Invalid verification code provided.',
  invalidPassword: 'Password does not conform to policy.',
  internalError: 'Internal Error.'
};